module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","events":"Seminare"},"en":{"back":"Zurück","events":"Events"}}')
  delete Component.options._Ctor
}
